import React from 'react';
import { useForm } from '@nerdgeschoss/react-use-form-library';
import { Form } from '../../../../../../components/Form/Form';
import { FormNumberField } from '../../../../../../components/Form/NumberField/FormNumberField';
import { ModalController } from '../../../../../../components/Modal/ControlledModal';
import { t } from '../../../../../../locales/translate';
import { handleError } from '../../../../../../model/notification';
import { setCartLimit } from '../../../../../../model/product';

export function CartLimitForm({
  controller,
  productId,
  productType,
}: {
  controller: ModalController<{ value: number | null | undefined }>;
  productId: string;
  productType: 'event' | 'product';
}): JSX.Element {
  const { model, fields, onSubmit, dirty, valid } = useForm({
    model: { ...controller.model },
    onSubmit: async () => {
      if (model.value !== undefined && model.value !== null) {
        await setCartLimit({
          cartLimit: model.value,
          productId,
          type: productType,
        });
        controller.close();
      }
    },
    onSubmitError: (error) => handleError(error),
    validations: {
      value: 'required',
    },
  });

  return (
    <Form model={model}>
      {() => {
        controller.configure({
          onSubmit,
          canSubmit: dirty && valid,
        });
        return (
          <>
            <FormNumberField
              {...fields.value}
              label={t.model.product.cartLimit}
              description={t.model.product.maximumItems}
            />
          </>
        );
      }}
    </Form>
  );
}
